import { RouterProvider } from 'react-router-dom';
import { LocaleProvider } from './locale/LocaleProvider';
import { router } from './router';

export function App() {
  return (
    <LocaleProvider>
      <RouterProvider router={router} />
    </LocaleProvider>
  );
}
